<template>
	<div id="fUser" v-loading.fullscreen.lock="visible.loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 阳光配餐报表</el-breadcrumb-item>
				<el-breadcrumb-item>中晚餐送餐表</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="container" v-if="power.search">
			<div class="handle-box left">
				<el-date-picker v-model="data.date" value-format="yyyy-MM-dd" size="large" class="left mr10">
				</el-date-picker>
				<el-checkbox-group v-model="data.type" size="mini" class="left mr10">
					<el-checkbox-button :label="8">中餐标准餐</el-checkbox-button>
					<el-checkbox-button :label="9">中餐特色</el-checkbox-button>
					<el-checkbox-button :label="14">中餐轻食</el-checkbox-button>
					<el-checkbox-button :label="10">晚餐标准餐</el-checkbox-button>
					<el-checkbox-button :label="11">晚餐特色</el-checkbox-button>
					<el-checkbox-button :label="15">晚餐轻食</el-checkbox-button>
				</el-checkbox-group>
				<el-radio-group v-model="data.addrType" size="mini" class="left mr10">
					<el-radio-button :label="1">厂内</el-radio-button>
					<el-radio-button :label="2">厂外</el-radio-button>
				</el-radio-group><br/>
				<el-checkbox-group v-model="data.refund" size="mini" class="left mr10">
					<el-checkbox-button :label="4">正常|已拒绝</el-checkbox-button>
					<el-checkbox-button :label="2">申请中</el-checkbox-button>
					<el-checkbox-button :label="3">已退款</el-checkbox-button>
				</el-checkbox-group>
				<el-button type="primary" icon="el-icon-search" @click="search" v-if="power.search">搜索</el-button>
			</div>
			<div class="handle-box right">
				<el-button type="primary" @click="toExport" v-if="power.export">
					<i class="if-lcon-daoru"></i>导出
				</el-button>
				<el-button type="primary" @click="toPrint" class="mr10" v-if="power.print">
					<i class="if-lcon-dayin"></i>打印
				</el-button>
			</div>
			<el-table id="sendMeal1ReportTable" ref="table" :data="data.rows" border class="table" row-key="roleid"
				@selection-change="handleSelectionChange" show-summary :summary-method="totalMethod">
				<el-table-column prop="idx" label="序号" width="70">
				</el-table-column>
				<el-table-column prop="phone" label="电话" width="120" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="addr" label="送餐地点" width="200" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="qs" label="轻食" width="65">
				</el-table-column>
				<el-table-column prop="sp" label="特色" width="65">
				</el-table-column>
				<el-table-column prop="nu" label="份数" width="65">
				</el-table-column>
				<el-table-column prop="pf1" label="米饭" width="70">
				</el-table-column>
				<el-table-column prop="pf2" label="面食" width="70">
				</el-table-column>
				<!--<el-table-column prop="pf" label="主食" width="90">
				</el-table-column>
				<el-table-column prop="ma1" label="全面" width="70">
				</el-table-column>
				<el-table-column prop="ma2" label="全米" width="70">
				</el-table-column>
				<el-table-column prop="ma3" label="半米" width="70">
				</el-table-column>-->
				<el-table-column prop="c1" label="小菜" width="65">
				</el-table-column>
				<el-table-column prop="c2" label="汤" width="65">
				</el-table-column>
				<el-table-column prop="total" label="合计" width="70">
				</el-table-column>
				<el-table-column prop="remark" label="备注" width="110">
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
	import printJS from 'print-js';
	export default {
		name: 'yhpremeal1report',
		data() {
			return {
				data: {
					filterstr: '',
					date: '',
					type: [],
					addrType: 1,
					refund: [4],
					rows: []
				},
				visible: {
					print: false,
					loading: false
				},
				power: {
					pageId: 84,
					search: false,
					export: false,
					print: false
				}
			}
		},
		methods: {
			search(change) {
				let ths = this;
				ths.visible.loading = true;
				let where = '';
				for (let i = 0; i < ths.data.type.length; i++) {
					where += ('&type=' + ths.data.type[i]);
				}
				where += ('&addrType=' + ths.data.addrType);
				for (let i = 0; i < ths.data.refund.length; i++) {
					where += ('&refund=' + ths.data.refund[i]);
				}
				window.ax.get('api/report/yhpos/sendmeal1list?date=' + ths.data.date + where + '&sign=' + window.$gloable
					.userinfo.sign, {}).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.data.rows = data.data;
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					console.log(err);
					ths.visible.loading = false;
				});
			},
			handleSizeChange(size) {
				this.data.size = size;
				this.search(true);
			},
			handleCurrentPageChange(current) {
				this.data.page = current;
				this.search();
			},
			handleSelectionChange(selections) {
				this.data.selections = selections;
			},
			totalMethod(param) {
				const { columns, data } = param;
				const sums = [];
				columns.forEach((column, index) => {
					if (index == 0) {
						sums[index] = '合计';
						return;
					} else if (index == 1 || index == 2 || index == 11) {
						sums[index] = '';
						return;
					}
					const values = data.map(item => Number(item[column.property]));
					if (!values.every(value => isNaN(value))) {
						sums[index] = values.reduce((prev, curr) => {
							const value = Number(curr);
							if (!isNaN(value)) {
								return prev + curr;
							} else {
								return prev;
							}
						}, 0);
					}
				});
				return sums;
			},
			toExport() {
				let ths = this;
				let where = '';
				for (let i = 0; i < ths.data.type.length; i++) {
					where += ('&type=' + ths.data.type[i]);
				}
				where += ('&addrType=' + ths.data.addrType);
				for (let i = 0; i < ths.data.refund.length; i++) {
					where += ('&refund=' + ths.data.refund[i]);
				}
				window.open('api/report/yhpos/exportsendmeal1list?date=' + ths.data.date + where + '&sign=' + window
					.$gloable.userinfo.sign, '_blank');
			},
			toPrint() {
				let printTarget = document.getElementById('printDOMElement');
				if (printTarget) {
					printTarget.remove();
				}
				let ths = this;
				let html = document.querySelector('#sendMeal1ReportTable').innerHTML;
				// 新建一个 DOM
				const div = document.createElement('div');
				const printDOMID = 'printDOMElement';
				div.id = printDOMID
				div.innerHTML = html;

				// 提取第一个表格的内容 即表头
				const th = div.querySelectorAll('.el-table__header-wrapper th');
				const ThsTextArry = [];
				for (let i = 0, len = th.length; i < len; i++) {
					if (th[i].innerText !== '') ThsTextArry.push(th[i].innerText);
				}

				// 删除多余的表头
				div.querySelector('.hidden-columns').remove();
				// 第一个表格的内容提取出来后已经没用了 删掉
				div.querySelector('.el-table__header-wrapper').remove();

				// 将第一个表格的内容插入到第二个表格
				let newHTML = '<tr>';
				for (let i = 0, len = ThsTextArry.length; i < len; i++) {
					newHTML += '<td style="text-align: left; font-weight: bold">' + ThsTextArry[i] + '</td>';
				}

				newHTML += '</tr>';
				div.querySelector('.el-table__body-wrapper table').insertAdjacentHTML('afterbegin', newHTML);
				// 将新的 DIV 添加到页面 打印后再删掉
				let typeName = '';
				if (ths.data.type.indexOf(8) > -1 || ths.data.type.indexOf(9) > -1 || ths.data.type.indexOf(14) > -1) {
					typeName += '中餐';
				}
				if (ths.data.type.indexOf(10) > -1 || ths.data.type.indexOf(11) > -1 || ths.data.type.indexOf(15) > -1) {
					if (typeName != '') {
						typeName = '、';
					}
					typeName += '晚餐';
				}
				
				let header = document.createElement('div');
				header.style.fontSize = '30px';
				header.fontWeight = 'border';
				header.textalign = 'center';
				header.innerText = ths.data.date + ' ' + typeName + ' 送餐表 ' + (ths.data.addrType == 1 ? '厂内' : '厂外');
				let first = div.firstChild;
				div.insertBefore(header,first);
				
				document.querySelector('body').appendChild(div);
				div.querySelector('table').border = 1;
				let tds = div.querySelectorAll('td');
				for (var i = 0; i < tds.length; i++) {
					tds[i].style.padding = '10px';
				}
				
				printJS({
					printable: printDOMID,
					type: 'html',
					scanStyles: false
				});
				
				div.remove();
			}
		},
		created() {
			let ths = this;
			ths.data.date = new Date().toDateFormatString('yyyy-MM-dd');
			ths.baseJS.initPower(ths.power);
			ths.search();
		},
		mounted() {}
	}
</script>

<style scoped>
	.is-current {
		background: #cccccc;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.left {
		float: left;
	}

	.right {
		float: right;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.del-dialog-cnt {
		font-size: 16px;
		text-align: center
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.mr10 {
		margin-right: 10px;
	}

	.m10 {
		margin: 10px;
	}

	.mt1 {
		margin-top: 1px;
	}

	.fr {
		float: right;
	}

	.form-warp {
		position: relative;
		width: 560px;
		height: 520px;
		padding-left: 200px;
		border: 1px solid #ccc;
	}

	.form-warp-left {
		position: absolute;
		left: 0;
		top: 0;
		width: 200px;
		height: 492px;
		padding-top: 28px
	}

	.department-search {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 28px;
		border-bottom: 1px solid #ddd;
		border-right: 1px solid #ddd;
	}

	.department-tree {
		position: relative;
		height: 490px;
		width: 100%;
		border-right: 1px solid #ddd
	}

	.form-warp-main {
		position: relative;
		height: 492px;
		width: 100%;
		padding-top: 28px
	}

	.employee-search {
		position: absolute;
		top: 0;
		left: 1px;
		width: 100%;
		height: 28px;
		border-bottom: 1px solid #ddd
	}

	.list {
		position: relative;
		height: 492px;
		width: 560px
	}

	.card-box {
		position: relative;
		float: left;
		width: 100px;
		height: 60px;
		border: 1px solid #ccc;
		background-color: #fff;
		border-radius: 3px;
		margin: 10px 0 0 10px;
		padding-left: 69px;
		overflow: hidden;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		-khtml-user-select: none;
		user-select: none;
		cursor: pointer
	}

	.card-box.active {
		border: 1px solid #ff5d5b;
		background: url(../../assets/img/selected_red.png) right top no-repeat
	}

	.card-box-img {
		position: absolute;
		left: 0;
		top: 0;
		width: 56px;
		height: 60px;
		line-height: 60px;
		padding-left: 5px;
		background-color: #ebebeb;
		border-right: 1px solid #ccc
	}

	.card-box-img img {
		border-radius: 45px;
		width: 50px;
		height: 50px;
		margin-top: 5px;
	}

	.card-box-content {
		padding: 6px 0
	}

	.card-box-content p {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0;
		font-size: 10px
	}

	.form-warp-right {
		position: absolute;
		top: 0;
		right: 0;
		height: 492px;
		width: 180px;
		border-left: 1px solid #ddd;
		padding-top: 28px;
		background-color: #fff;
		z-index: 10;
		transition: all 300ms;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.form-warp-right.hide {
		width: 0px;
	}

	.form-warp-right-close {
		position: absolute;
		top: 7px;
		right: 4px;
		width: 12px;
		height: 13px;
		display: block;
		cursor: pointer
	}

	.form-warp-right-close:hover {
		background-position: 0 -12px
	}

	.form-warp-right-title {
		position: absolute;
		top: 0;
		right: 0;
		height: 28px;
		line-height: 27px;
		padding-left: 10px;
		width: 170px;
		border-bottom: 1px solid #ddd;
		cursor: pointer
	}

	.selected-list-warp {
		position: relative;
		height: 492px;
		width: 180px;
	}

	.selected-box {
		position: relative;
		width: 150px;
		height: 55px;
		border: 1px solid #ccc;
		border-radius: 4px;
		margin: auto;
		margin-top: 10px;
		padding: 5px 0 0 10px
	}

	.selected-box p {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0
	}

	.remove {
		position: absolute;
		top: 2px;
		right: 2px;
		width: 12px;
		height: 13px;
		display: block;
		cursor: pointer;
		opacity: 0.5
	}

	.remove:hover {
		opacity: 1
	}

	.selected-btn {
		position: absolute;
		top: 0;
		right: 1px;
		height: 100%;
		width: 80px;
		line-height: 27px;
		text-align: center;
		border-left: 1px solid #ddd;
		cursor: pointer;
		background-color: #eee;
		color: #666
	}

	.selected-btn:hover {
		color: #333
	}

	.form-control {
		border: 0;
		height: 100%;
	}

	.input-query {
		position: absolute;
		right: 146px;
		top: 5px;
		color: #ccc;
		font-size: 16px;
		cursor: pointer
	}

	.select-all {
		position: absolute;
		top: 0;
		right: 80px;
		height: 100%;
		width: 60px;
		line-height: 27px;
		text-align: center;
		border-left: 1px solid #ddd;
		cursor: pointer;
		background-color: #eee;
		color: #666
	}

	.span-ellipsis {
		width: 100%;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		display: block;
	}
</style>
